<template>
  <component v-bind:is="headingTitle" class="jm-uppercase jm-mb-3">
    <slot></slot
  ></component>
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    h: {
      type: String,
      default: '1'
    }
  },
  computed: {
    headingTitle() {
      return `h${this.h}`
    }
  }
}
</script>
